import { Link, graphql } from "gatsby"

import { Demosuche } from "components/page-components/Ausschreibungsdienste"
import { EmailCoursesSignupModule } from "components/page-components/Signup-Modules"
import { Helmet } from "react-helmet"
import Layout from "components/structure-components/layout"
import React from "react"
import { SEOComponent } from "components/seo-components"
import { StaticImage } from "gatsby-plugin-image"
import { createTitleTags } from "components/noticepage_components/utils"
import doenerCase from "scripts/doenerCase"

const NoticePage = ({ location, data }) => {
  const {
    Notice: {
      bi_platform,
      categories_id_primary,
      RefIDStringBI,
      places_of_delivery_struct,
      categories_data,
      TitelOnline,
      ValidUntil,
      ZoneOfRequest,
    },
  } = data

  const [title_tag, h1_tag] = createTitleTags({
    current_category_data: categories_data.find(
      ({ category_id }) => category_id === categories_id_primary
    ),
    current_cat_id: categories_id_primary,
    main_place_of_delivery: places_of_delivery_struct?.[0]?.City,
    TitelOnline,
    ZoneOfRequest,
  })

  const breadcrumb_array = [
    {
      type: "BreadcrumbLink",
      content: `B_I MEDIEN`,
      link: `/`,
      react_key: "footer_breadcrumb_item_0",
      ressort: "ausschreibungsdienste",
    },
    {
      type: "BreadcrumbLink",
      content: `Aufträge finden`,
      link: `/ausschreibungsdienste`,
      react_key: "footer_breadcrumb_item_1",
      ressort: "ausschreibungsdienste",
    },
    {
      type: "BreadcrumbLink",
      content: `Ausschreibungen`,
      link: `/ausschreibungsdienste/ausschreibungen`,
      react_key: "footer_breadcrumb_item_2",
      ressort: "ausschreibungsdienste",
    },
    {
      type: "BreadcrumbLink",
      content: `Region`,
      link: `/ausschreibungsdienste/ausschreibungen/region`,
      react_key: "footer_breadcrumb_item_3",
      ressort: "ausschreibungsdienste",
    },
    {
      type: "BreadcrumbLink",
      content: `Ausschreibungen aus ${places_of_delivery_struct?.[0].State}`,
      link: `/ausschreibungsdienste/ausschreibungen/region/${doenerCase(
        places_of_delivery_struct?.[0].State
      )}`,
      react_key: "footer_breadcrumb_item_4",
      ressort: "ausschreibungsdienste",
    },
    {
      type: "BreadcrumbSpan",
      content: TitelOnline,
      link: "",
      react_key: "footer_breadcrumb_item_5",
      ressort: "mitternachtsblau",
      ignore_json: true,
    },
  ]
  const delete_date = new Date((ValidUntil + 1200000) * 1000).toISOString()

  return (
    <Layout {...{ location, breadcrumb_array }}>
      <SEOComponent
        brand="B_I ausschreibungsdienste"
        title={title_tag}
        description={title_tag}
      />
      <Helmet>
        <meta name="robots" content={`unavailable_after: ${delete_date}`} />
      </Helmet>
      <div className="has-background-mitternachtsblau-5">
        <div className="container py-6">
          <div className="pb-3">
            <div className="columns mb-0">
              <div className="column mt-auto pb-0">
                <h1
                  className={
                    bi_platform
                      ? "has-text-weight-bold has-text-mitternachtsblau mb-3"
                      : "title is-3 has-text-mitternachtsblau mb-3"
                  }
                >
                  {h1_tag}
                </h1>
                <h2
                  className={
                    bi_platform
                      ? "title is-3 has-text-mitternachtsblau mb-3"
                      : "has-text-weight-bold has-text-mitternachtsblau mb-0"
                  }
                >
                  {TitelOnline}
                </h2>
              </div>
              <div className="column is-narrow pb-0">
                <div
                  className="tag is-mitternachtsblau-30 px-4 mb-auto"
                  style={{ borderRadius: "12px" }}
                >
                  ID: {RefIDStringBI}
                </div>
              </div>
            </div>

            <hr className="is-mitternachtsblau-30 mx-3 mb-5" />
          </div>
          <div className="box mx-3 my-6 ">
            <div className="columns is-vcentered is-variable is-8 py-5">
              <div className="column is-4 has-text-centered">
                <StaticImage
                  src="../images/illustrations/evergabe/termine-und-fristen-blue-sweater.png"
                  width={300}
                  placeholder="blurred"
                  layout="constrained"
                  alt={TitelOnline}
                />
              </div>
              <div className="column is-8">
                <p className="title is-4 has-text-mitternachtsblau mt-4">
                  Schade – Die Frist dieser Ausschreibung ist leider bereits
                  verstrichen.
                </p>
                <p className="title is-4 has-text-mitternachtsblau mt-4">
                  Erlauben Sie uns, Ihnen zukünftig automatisch und rechtzeitig
                  passende Aufträge per E-Mail zuzuschicken? <br />
                  <br /> So verpassen Sie nichts.
                </p>
                <div className="buttons is-right">
                  <Link
                    to="/ausschreibungsdienste/ausschreibungen"
                    className="button is-tertiary"
                  >
                    Mehr erfahren
                  </Link>
                  <a
                    href={`${process.env.GATSBY_AD_SOFTWARE_PRODUCT_REGISTER_ADDRESS}?productId=${process.env.GATSBY_AD_SOFTWARE_PRODUCT_FREE_TEST_ID}`}
                    className="button is-sonnengelb"
                  >
                    Kostenfrei testen
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section py-6 has-background-mitternachtsblau">
          <p className="has-text-centered has-text-white title is-3 is-size-4-mobile pt-6 mb-3">
            Sie suchen passende Aufträge für Ihre Firma?
          </p>
          <div className="columns is-centered">
            <div className="column is-4">
              <p className="has-text-centered has-text-white pb-5">
                Egal ob Bau-, Liefer-, oder Dienstleistungen, in unserer
                B_I&nbsp;ausschreibungsdatenbank finden Sie garantiert
                zahlreiche Ausschreibungen auch für Ihre Firma.
              </p>
            </div>
          </div>
          <Demosuche withoutCTA />
          <p className="has-text-centered has-text-white  pb-6 pt-4">
            Aktuell{" "}
            <span className="has-text-weight-bold">mehr als 10.000</span>{" "}
            Ausschreibungen verfügbar.
          </p>
        </div>
        <div className="section is-clipped">
          <div className="my-6">
            <EmailCoursesSignupModule />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default NoticePage

export const pageQuery = graphql`
  query (
    $id: String! # $in_one_week: Int
  ) {
    Notice: noticeDoc(id: { eq: $id }) {
      bi_platform
      categories_id_primary
      categories_data {
        category_id
        landingpage_link
        level
        notice_count
        seo_name
        short_name
      }
      TitelOnline
      RefIDStringBI
      places_of_delivery_struct {
        PostalCode
        State
        City
        city_lp_data {
          city_lp_name
          city_lp_state
        }
      }
      ValidUntil
      ZoneOfRequest
    }
  }
`
